import { YupArraySchema, yup } from '@framework/validation';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema';
import { LazyWidgetSchema } from '../../../LazyWidgetSchema';
import { Widget } from '../../../Widget';
import { IContainerWidget } from '../IContainerWidget';

export const CommonContainerWidgetConfigSchema: yup.ObjectSchema<IContainerWidget> =
  CommonBaseWidgetSchema.shape({
    children: yup
      .array()
      .required()
      // Valido il form nella sua totalità solo se non è una bozza (e.g. quando viene pubblicato)
      .when('$isDraft', ([isDraft], schema) => {
        if (!isDraft) {
          return schema.of(LazyWidgetSchema).required();
        }
        return schema.optional().default([]);
      })
      .default([] as Widget[]) satisfies YupArraySchema<Widget>,
  })
    .required()
    .noUnknown();
